<ng-container *ngIf="deviceIsTrusted">
  <h2>Check your email to login</h2>
  <p>
    We've sent a magic link to your email address which you can use to login to
    {{ 'CORE.PRODUCT_NAME' | transloco }}.
  </p>
</ng-container>

<ng-container *ngIf="!deviceIsTrusted">
  <h2>We don't recognize this device</h2>
  <p>
    In order to verify your identity, we've sent a magic link to your email
    <strong>{{ email }}</strong>
    .
  </p>
  <p>Click on the link in your email to login.</p>
</ng-container>
